import $ from "jquery";

import CollectionCarousel from "../../components/collection-carousel";
import updateQuerystring from "../helpers/update_querystring";

import React from "react";
import { Waypoint } from "react-waypoint";
import classnames from "classnames";

import { connect } from "react-redux";
import _isEmpty from "lodash/isEmpty";

import { IconlistLoading } from "../../components/nounproject-iconlist-classic-loading";
import { IconRow } from "../../components/nounproject-iconlist-classic-row";
import { phases, licenses } from "../../reducers/download";

import { DoubleClickAd } from "./results-doubleclick-ad";

class Icon_List extends React.Component {
    componentWillReceiveProps(nextProps) {
        let iconId = this.props.activeIconId;
        let nextIconId = nextProps.activeIconId;
        if (iconId != nextIconId) {
            this.selectIcon(nextProps.activeIconId, nextProps);
        }
    }

    componentWillMount() {
        this.selectIcon(this.props.activeIconId);
    }
    constructor(props) {
        super(props);

        this.state = {
            showHero: false,
            iconsPerRow: 6,
            heroRowKey: "row.0"
        };
    }

    buildUrl(icon_id, props) {
        props = props || this.props;
        // should be simpler
        let iconPathMatch, path, qs, termIconPathMatch, termPathMatch, url;
        let { location } = props;
        path = location.pathname;
        qs = location.search;
        termPathMatch = /\/term\/[^\/]+\//;
        termIconPathMatch = /\/term\/[^\/]+\/\d+\//;
        iconPathMatch = /\/\d+\/$/;
        if (path.match(termIconPathMatch) && icon_id) {
            url = path.replace(iconPathMatch, "/" + icon_id + "/") + qs;
        } else if (path.match(termIconPathMatch)) {
            url = path.replace(iconPathMatch, "/") + qs;
        } else if (path.match(termPathMatch) && icon_id) {
            url = path + icon_id + "/" + qs;
        } else {
            url = updateQuerystring("i", icon_id, path + qs);
        }
        return url;
    }
    setUrlState(url, props) {
        props = props || this.props;
        if (!props.history) {
            return;
        }
        let { location } = props;
        if (location.pathname + location.search !== url) {
            props.history.push(url);
        }
    }
    selectIcon(iconId, props) {
        props = props || this.props;
        if (iconId && iconId.id) {
            iconId = iconId.id;
        }
        let rowIndex = 0;
        let { icons } = props;
        if (icons && icons.length) {
            let index = icons.findIndex(i => i.id == iconId);
            if (index >= 0) {
                rowIndex = Math.floor(index / 6);
            }
        }

        this.setUrlState(this.buildUrl(iconId, props), props);

        return this.setState({
            showHero: !!iconId,
            heroRowKey: `row.${rowIndex}`,
            isHeroFetching: false
        });
    }

    handleIconShift(direction) {
        let iconIndex, newIconIndex;
        if (this.props.activeIconId) {
            this.props.icons.forEach(icon => {
                if (icon.id === this.props.activeIconId) {
                    iconIndex = this.props.icons.indexOf(icon);
                }
            });
            switch (direction) {
                case "next":
                    newIconIndex = iconIndex + 1;
                    break;
                case "prev":
                    newIconIndex = iconIndex - 1;
                    break;
                case "up":
                    newIconIndex = iconIndex - this.state.iconsPerRow;
                    break;
                case "down":
                    newIconIndex = iconIndex + this.state.iconsPerRow;
                    break;
            }
            if (newIconIndex > -1 && newIconIndex < this.props.icons.length) {
                return this.selectIconByIndex(newIconIndex);
            }
        }
    }
    getIndexOfIconById(id) {
        let index;
        this.props.icons.forEach(icon => {
            if (icon.id === id) {
                index = this.props.icons.indexOf(icon);
            }
        });
        return index;
    }
    selectIconByIndex(index) {
        let icon = this.props.icons[index];
        if (icon) {
            return this.selectIcon(icon);
        }
    }
    handleHeroClose(e) {
        if (e) {
            e.preventDefault();
        }

        $(".nounproject-icon-hero").animate(
            {
                opacity: 0
            },
            100
        );
        return $(".nounproject-icon-hero").slideUp(200, () => {
            this.setState({
                showHero: false
            });
            this.selectIcon(null);
        });
    }

    shouldSeeAds() {
        if (this.props.currentUser === undefined) {
            return true;
        }
        if (this.props.currentUser.is_anonymous) {
            return true;
        }
        if (!this.props.currentUser.permissions.market === "premium") {
            return true;
        }
        return false;
    }

    buildElements(icons) {
        let adRowKey, currentRow, elements, rowKey, showHero;
        currentRow = 0;
        elements = [];
        while (icons.length > 0) {
            rowKey = "row." + currentRow;
            adRowKey = "row-" + currentRow + "-ad";
            showHero = false;
            currentRow++;
            if (rowKey === this.state.heroRowKey && this.state.showHero) {
                showHero = true;
            }
            if (this.shouldSeeAds() && (currentRow + 3) % 6 === 0) {
                if (currentRow !== 9) {
                    elements.push(
                        <section
                            key={adRowKey}
                            className="row-container advertisement"
                        >
                            <div
                                className="Grid-cell-row container _6"
                                style={{ background: "#ffffff" }}
                            >
                                <DoubleClickAd />
                            </div>
                        </section>
                    );
                } else {
                    elements.push(<CollectionCarousel key={adRowKey} />);
                }
            } else if (currentRow === 9) {
                elements.push(<CollectionCarousel key={adRowKey} />);
            }

            elements.push(
                <IconRow
                    icons={icons.splice(0, this.state.iconsPerRow)}
                    iconsPerRow={this.state.iconsPerRow}
                    showHero={showHero}
                    key={rowKey}
                    heroIconId={this.props.activeIconId}
                    onSelectIcon={this.selectIcon.bind(this)}
                    onHeroClose={this.handleHeroClose.bind(this)}
                />
            );
        }
        return elements;
    }

    handleInfiniteLoad(evt) {
        if (
            !this.props.endOfResults &&
            this.props.loadIcons &&
            !this.props.processing
        ) {
            this.props.loadIcons();
        }
    }
    render() {
        let iconList, loading;

        if (this.props.icons.length > 0) {
            iconList = this.props.icons.slice(0);
            iconList = this.buildElements(iconList);
        }

        if (this.props.processing) {
            loading = <IconlistLoading iconsPerRow={this.state.iconsPerRow} />;
        }

        let listClass = classnames("icon-list", {
            "icon-list-showing-hero": this.state.showHero
        });
        let waypoint;
        if (iconList && iconList.length) {
            waypoint = (
                <Waypoint
                    onEnter={this.handleInfiniteLoad.bind(this)}
                    threshold={1.0}
                />
            );
        }
        return (
            <div data-test-id="icon-list" className={listClass}>
                {iconList}
                {waypoint}
                {loading}
            </div>
        );
    }
    handleKeyDown = event => {
        let { keyCode } = event;
        let down = 40,
            esc = 27,
            left = 37,
            right = 39,
            up = 38;

        if ($("input:focus").length > 0) {
            // Check to see if any input is focused.
            return;
        }
        if ($(".download-modal").length === 1) {
            return;
        }

        if (this.props.preventClose) {
            return;
        }

        if (this.props.blockNavigation && keyCode != esc) {
            return;
        }
        if ($(document.activeElement).hasClass("custom-color")) {
            return;
        }
        if ($(document.activeElement).prop("id") === "search-input") {
            return;
        }
        if (event.originalEvent && event.originalEvent.getModifierState) {
            if (event.originalEvent.getModifierState("Alt")) {
                return;
            }
        }
        if (
            keyCode === left ||
            keyCode === right ||
            keyCode === up ||
            keyCode === down
        ) {
            event.preventDefault();
        }

        switch (keyCode) {
            case right:
                this.handleIconShift("next");
                break;
            case left:
                this.handleIconShift("prev");
                break;
            case up:
                this.handleIconShift("up");
                break;
            case down:
                this.handleIconShift("down");
                break;
            case esc:
                this.handleHeroClose();
        }
    };
    componentDidMount() {
        $(document).on("keydown", this.handleKeyDown);
    }
    componentWillUnmount() {
        $(document).off("keydown", this.handleKeyDown);
    }
}

function mapStateToProps(state, props) {
    let currentUser;

    let { download, apiResponse, modal, user, stripe, icons } = state;
    let { status, license, waitingForAuth } = download;
    let { endOfResults, processing } = icons;

    let notInModal =
        status != phases.DOWNLOAD_READY && license != licenses.CREATIVE_COMMONS;
    let downloadFlowInProgress =
        status && status != phases.INITIAL && notInModal;
    let modalOpen = !_isEmpty(modal.all);
    let blockNavigation = downloadFlowInProgress || waitingForAuth || modalOpen;
    let preventClose = download.processing || stripe.processing;
    if (user.is_anonymous !== undefined) {
        currentUser = user;
    }

    return {
        apiResponse,
        currentUser,
        blockNavigation,
        preventClose,
        endOfResults,
        processing
    };
}

// export default Icon_List;
export default connect(
    mapStateToProps,
    {}
)(Icon_List);
